module.exports = __webpack_public_path__ + "img/uploadSimple.6e2b479d.svg";